// extracted by mini-css-extract-plugin
export default {"card":"card__kDnBMXQ4","mobileClickOffWorkaroundWrapper":"mobileClickOffWorkaroundWrapper__DG2Xypqa","continueButton":"continueButton__dIcGBEmz"};